import React from "react";
import { NewTab, PageTab } from "../../../components";
import ApprovalDelegation from "./TimesheetSettings/ApprovalDelegation";
import DelegationOnBehalf from "./TimesheetSettings/DelegationOnBehalf";
import Approvals from "./TimesheetSettings/Approvals";
import AdditionalNotifiers from "./TimesheetSettings/AdditionalNotifiers";

const TimesheetSettings = () => {
  const TimesheetSettingMenus = [
    {
      title: "Approval Delegation",
      page: <ApprovalDelegation />,
      type: "main",
    },

    {
      title: "Delegation on Behalf",
      page: <DelegationOnBehalf />,
      type: "main",
    },
    {
      title: "Approvals",
      page: <Approvals />,
      type: "main",
    },
    {
      title: "Additional Notifiers",
      page: <AdditionalNotifiers />,
      type: "main",
    },
    {
      title: "Back",
      link: "/timesheet",
      type: "sub",
      icon: "arrow_left_alt",
    },
  ];

  return (
    <div className="flex-1 flex overflow-hidden">
      <NewTab
        tabs={TimesheetSettingMenus}
        color="black"
        //activeColor="primary"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="timesheet-settings"
      />
    </div>
  );
};

export default TimesheetSettings;
